'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = require('./components/IconButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/icon/index.js
// module id = 1042
// module chunks = 1